interface IDaySchedulingsProps {
  dayTitle: string;
  vehicles: string[];
}

const DaySchedulings = ({ dayTitle, vehicles }: IDaySchedulingsProps) => {
  return (
    <div className="padding-10 margin-top-10">
      <div
        className="flex text-size-16 text-medium padding-bottom-10"
        style={{ lineHeight: "34px" }}
      >
        <span className="rioglyph rioglyph-calendar" />
        {dayTitle}
      </div>
      <div>
        {vehicles.map((vehicle, index) => (
          <div
            key={index}
            className="padding-5 text-size-10 display-grid grid-cols-2-1fr-max-content"
          >
            <div className="text-bold flex">
              <div className="bg-highlight-darker rounded-circle width-10 height-10 margin-3"></div>
              <div className="padding-left-5">
                {vehicle}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DaySchedulings;
